import React, { memo } from "react";
import SubVariable from "../../../common/icons/Variables/subVariable";

const MenuInnerItem = (props) => {
  const {
    isActive,
    isHover,
    isExactPathname,
    dataTestId,
    name,
    subItems,
    subItem,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;

  return (
    <div className="li-wrapper">
      {subItem && <SubVariable className="sub-item-icon" />}
      <li
        data-testid={`deals-menu-item-${dataTestId ? dataTestId : name}`}
        className={`${isActive ? "active" : ""} ${isHover ? "hover" : ""} ${
          subItem ? "sub-item" : ""
        }`}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {name}
      </li>
      {!subItems && isExactPathname && (
        <div className={`active-border ${subItem ? "sub-item-border" : ""}`} />
      )}
    </div>
  );
};

export const MenuItem = memo(MenuInnerItem);
